<button class="btn btn-primary btn-orange getStartButton fm-prompt"
    [ngClass]="'btn-' + size"
    (click)="action.emit()">
    <span class="btn-orange-font">{{text}}</span>
    <i class="pi pi-arrow-right text-white arrow-icon"></i>
</button>
